import { api } from './api.ts';

export interface KeyResultInput {
  title: string;
  target_value: number;
  unit: string;
}

export interface ObjectiveInput {
  title: string;
  description?: string;
  period_type: 'annual' | 'quarterly';
  period_start?: string;
  period_end?: string;
  key_results: KeyResultInput[];
}

export interface ObjectiveUpdateInput {
  title?: string;
  description?: string;
  status?: 'active' | 'archived';
  period_type?: 'annual' | 'quarterly';
  period_start?: string;
  period_end?: string;
}

export interface KeyResultUpdateInput {
  title?: string;
  target_value?: number;
  unit?: string;
  status?: 'active' | 'archived';
}

export const listObjectives = async (params?: { period_type?: string; status?: string }) => {
  const response = await api.get('/api/v1/objectives', { params });
  return response.data;
};

export const createObjective = async (payload: ObjectiveInput) => {
  const response = await api.post('/api/v1/objectives', payload);
  return response.data;
};

export const updateObjective = async (id: number, payload: ObjectiveUpdateInput) => {
  const response = await api.patch(`/api/v1/objectives/${id}`, payload);
  return response.data;
};

export const getObjective = async (id: number) => {
  const response = await api.get(`/api/v1/objectives/${id}`);
  return response.data;
};

export const updateKeyResult = async (id: number, payload: KeyResultUpdateInput) => {
  const response = await api.patch(`/api/v1/key-results/${id}`, payload);
  return response.data;
};

export const createKeyResult = async (objectiveId: number, payload: KeyResultInput) => {
  const response = await api.post(`/api/v1/objectives/${objectiveId}/key-results`, payload);
  return response.data;
};

export const listIndicators = async (keyResultId: number) => {
  const response = await api.get(`/api/v1/key-results/${keyResultId}/indicators`);
  return response.data;
};

export const addIndicator = async (keyResultId: number, payload: { month: string; value: number }) => {
  const response = await api.post(`/api/v1/key-results/${keyResultId}/indicators`, payload);
  return response.data;
};
